

export const VersionUtils = {
    isVersionHigher: (newVersion, installedVersion) =>
    {
        // If no installed version, 2 indicates uninstalled
        if (!installedVersion) return 2;

        // Split versions into arrays of numbers
        const newParts = newVersion.split('.').map(Number);
        const installedParts = installedVersion.split('.').map(Number);

        // Pad to max length with 0s
        const maxLength = Math.max(newParts.length, installedParts.length);
        while (newParts.length < maxLength) newParts.push(0);
        while (installedParts.length < maxLength) installedParts.push(0);

        // Compare each part from left to right
        for (let i = 0; i < maxLength; i++) {
            if (newParts[i] > installedParts[i]) return 1; // 1 indicates this version is higher than installed
            if (newParts[i] < installedParts[i]) return -1; // -1 indicates this version is higher than installed
        }

        // Versions are equal
        return 0;
    },
    hasMajorOrMinorDifference: (version1, version2) => {
        const parts1 = version1.split('.').map(Number);
        const parts2 = version2.split('.').map(Number);

        // Compare major (index 0) and minor (index 1) versions
        return parts1[0] !== parts2[0] || parts1[1] !== parts2[1];
    }
}